import { jwtDecode } from 'jwt-decode';
import { BayerIdTokenPayload } from '../interfaces/oauth';

const RESTRICTED_AD_CUSTOMER_GROUP_NAMES = ['LOEWE', 'TEEN'];
const ALLOWED_CUSTOMER_GROUP_NAMES = ['LOEWE', 'TEEN', 'CLUB', 'SILBERLOEWE'];

export interface BayerClaims {
  userName: string | null;
  accessDenied: boolean | null;
  belongsToAdRestrictedGroup: boolean;
}

/** Pure function: derives display-name / access-restriction claims from a Bayer id_token. */
export function deriveBayerClaims(idToken: string | null): BayerClaims {
  if (!idToken) {
    return { userName: null, accessDenied: null, belongsToAdRestrictedGroup: false };
  }

  const decoded = jwtDecode(idToken) as BayerIdTokenPayload;
  const customerGroups = (decoded.customer_groups ?? '').split(',');

  return {
    userName: decoded.profile_name ?? null,
    belongsToAdRestrictedGroup: customerGroups.some((group) => RESTRICTED_AD_CUSTOMER_GROUP_NAMES.includes(group)),
    accessDenied: !customerGroups.some((group) => ALLOWED_CUSTOMER_GROUP_NAMES.includes(group)),
  };
}
